<template>
  <el-dialog title="配件申请单信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">

          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent"
                      show-overflow height="390" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">
              <template #form>
                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="配件单号:" field="orderNo">
                    <template v-slot>
                      <el-input v-model="formData.fuzzySearchValue" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
                    float: right;
                    margin-top: -39px;">
                    <!--                    <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                    <!--                                status="primary" plain>重置</vxe-button>-->
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
              <template #areaSlots="{ row }">
                <span>{{ row.deliverProvince }}{{ row.deliverCity }}{{ row.deliverCounty }}{{ row.deliverTown }}</span>
              </template>
              <template #stat="{ row }">
                <span class="txt-status " v-if="row.stat == 0">制单</span>
                <span class="txt-status " v-else-if="row.stat == 1">申请</span>
                <span class="txt-status neutral" v-else-if="row.stat == 2">审核</span>
                <span class="txt-status " v-else-if="row.stat == 3">已发货</span>
                <span class="txt-status " v-else-if="row.stat == 4">已收货</span>
                <span class="txt-status disable" v-else-if="row.stat == 9">驳回</span>
                <span class="txt-status " v-else-if="row.stat == 98">已结算</span>
                <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
                <span v-else></span>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'siteId', 'bigSiteId','orderNo','userMobile','isHandle', 'statBegin', 'statEnd', 'settleType','rejectOrderId',
    'businessType', 'isExchange','isWorkBill','rhs'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.initSetting();
    this.formData.siteId = this.siteId
    this.formData.bigSiteId = this.bigSiteId
    this.formData.userMobile = this.userMobile
    this.formData.isHandle = this.isHandle
    this.formData.orderNo = this.orderNo
    this.formData.rejectOrderId = this.rejectOrderId
    // 工单类型
    this.formData.settleType = this.settleType
    this.formData.statBegin=this.statBegin
    this.formData.statEnd=this.statEnd
    this.formData.businessType=this.businessType
    this.formData.isExchange=this.isExchange
    this.formData.isWorkBill = this.isWorkBill
    this.formData.rhs = this.rhs
    this.statMap = {
      1: '登记',
      2: '发布',
      5: '已派网点',
      6: '网点已接单',
      9: '已派师傅',
      10: '师傅已接单',
      11: '已预约',
      13: '已出发',
      17: '已上门',
      20: '完工暂存',
      30: '寄修待确认',
      31: '待寄件',
      32: '已寄待签收',
      36: '待维修',
      37: '修好待寄出',
      38: '客户待签收',
      40: '退换待确认',
      41: '旧机待退回',
      42: '旧机待签收',
      43: '旧机已签收',
      44: '新机待寄出',
      45: '新机已寄出',
      47: '新机待签收',
      48: '新机已签收',
      49: '退换被驳回',
      61: '已完工',
      62: '网点确认完工',
      63: '中心完工审核',
      64: '总部完工审核',
      91: '待结算',
      92: '结算驳回',
      93: '结算中止',
      94: '已结算',
      97: '申请关闭',
      98: '挂起',
      99: '取消',
    };
  },

  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      columns: [
        {type: "radio", width: 40, title: '', resizable: false, fixed: 'left'},
        {title: '配件单号', field: 'applyNo', width: 200,},
        {title: '状态', field: 'stat', width: 125, slots: {default: 'stat'}},
        {title: '收货地址', field: 'area', width: 235, slots: {default: 'areaSlots'}},
        {title: '申请数量', field: 'applyQtyAll', width: 80,},
        {title: '创建人', field: 'createBy', width: 80,},
        {title: '创建时间', field: 'createTime', width: 150,},
      ],


      total: 0,
      searchOrderNo: null,
      data: [],


      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        partsNo: null,
        fuzzySearchValue:null,
        siteId: null,
        bigSiteId: null,
        stat: null,
        statBegin:null,
        statEnd:null,
        isSuspendSelect:1
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      selectedRow: {
        orderId: null, orderNo: null
      }
    };
  },




  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent(e) {
      console.log(e.row.id, '单元格点击事件')
    },


    radioChangeEvent({row}) {
      this.selectedRow = {applyId: row.id, applyNo: row.applyNo
      }
    },



    commitRow() {
      this.$mask.open()

      if (this.selectedRow.orderNo !== null) {
        this.$emit('commit', this.selectedRow)
        this.dialogClose()
      } else {
        this.$message.warning('请先选中数据')
      }
      this.$mask.close()

    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      this.formData.userName = this.searchSiteName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.spPartsApplyHeader.getPageDataUrl,
        param: this.formData,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}


::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
